t = require('views/internal/teacup-with-helpers')('card_detail_toggle_button')

module.exports = t.renderable ({ isOn, selectorOn, selectorOff, title, text, icon, disabled, minimizedCardBack }) ->
  return if disabled
  if minimizedCardBack
    classes =
      'button-link card-detail-section-mini-button toggle-button': true
      'is-on': isOn
      "#{selectorOff}": !isOn
      "#{selectorOn}": isOn
    t.a { class: t.classify(classes), title: t.l(title || text), href: '#' }, ->
      if !isOn then t.icon icon
      t.span '.card-detail-section-mini-button-text', text
      if isOn
        t.span '.on', ->
          t.icon icon, { class: 'light' }
  else
    classes =
      'button-link toggle-button': true
      'is-on': isOn
      "#{selectorOff}": !isOn
      "#{selectorOn}": isOn
    t.a { class: t.classify(classes), title: t.l(title || text), href: '#' }, ->
      t.icon icon, text
      t.span '.on', ->
        t.icon 'check', { class: 'light' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_toggle_button.coffee